


import React from 'react';
import { Page, Text, View, Document, StyleSheet,Font  } from '@react-pdf/renderer';
import { withRouter } from 'react-router-dom'
import ReactPDF, { PDFViewer } from '@react-pdf/renderer';
import font from '../../../fonts/bpg_mrgvlovani_caps_2010.ttf'

Font.register({
  family: 'geo',
  src: font
});
const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontFamily:'geo',
      fontSize: 11,
      textAlign: 'center',
     
    },
    author: {
      fontFamily:'geo',
      fontSize: 10,
      textAlign: 'center',
      marginBottom: 40
    },
    subtitle: {
      fontFamily:'geo',
      fontSize: 15,
      margin: 12
      
    },
    text: {
      fontFamily:'geo',
      margin: 5,
      fontSize: 9,
      display: 'flex'

    },
    test: {
      fontFamily:'geo',
      fontSize: 10,
      width: 500,
      minWidth: 500,
      backgroundColor: 'red'
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100,
    },
    header: {
      fontFamily:'geo',
      fontSize: 12,
      marginBottom: 15,
      textAlign: 'center',
      color: 'grey',
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  });
class RemoveContractDocument extends React.Component{
    // this.props.match.params.id
    render(){
        return (
            <PDFViewer style={{"width":"100%","height":"100%"}}>
            <Document>
                <Page style={styles.body}>
                  <Text style={styles.title}>
                  მიღება-ჩაბარების აქტი
                  </Text>
                  <Text style={styles.author}>
                    (დაბრუნება)
                  </Text>
                  
                  <Text style={styles.text}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                   _______________ 2020წ
                  </Text>
                  <Text style={{marginTop:10}}></Text>
                  <Text style={styles.text}>
                  ერთი მხრივ, {this.props.match.params.firstname} {this.props.match.params.lastname} პ/ნომერი {this.props.match.params.personal_number} სახით(შემდგომში „ აბონენტი“);
                  </Text>
                  <Text style={styles.text}>
                  და მეორე  მხრივ, შპს „სერვისბოქსი“ ს/კ 405113176 (შემდგომში „ სერვისბოქსი’’)  წარმოდგენილი  იაგო შიოლაშვილის (პ/ნ 01021002140) სახით
                  </Text>
                  <Text style={styles.text}>
                  „ნების თავისუფალი  გამოვლენის საფუძველზე ვაფორმებთ წინამდებარე მიღება-ჩაბარების აქტს და ვთანხმდებით შემდეგზე:
                  </Text>
                  <Text style={styles.text}>
                  1. „აბონენტი“ აბრუნებს, ხოლო „სერვისბოქსი“ იღებს  სააბონენტო ხელშეკრულება N {this.props.match.params.id} საფუძველზე გადაცემულ   შემდეგ „მოწყობილობას“:
                  </Text>
                  <Text style={styles.text}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; _____  1 (ერთი) ცალი SET TOP BOX (შემდგომში „მოდემი“), რომელთა მაკ 
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;მისამართია :&nbsp;____________________________________&nbsp;სერიული ნომერი :&nbsp;_______________
                  </Text>
                  <Text style={styles.text}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; _____  1 (ერთი) ცალი --კვების ბლოკი,
                  </Text>
                  <Text style={styles.text}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; _____  1 (ერთი) ცალი -- დისტანციური მართვის პულტი,
                  </Text>
                  <Text style={styles.text}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; _____  1 (ერთი) ცალი -- HDMI სადენი /RCA სადენი,
                  </Text>
                  <Text style={styles.text}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; _____  1 (ერთი) ცალი -- სვიჩი-S105 (5 port) Tenda
                  </Text>
                  <Text style={{marginTop:50}}></Text>
                  <Text style={styles.text}>
                    2.წინამდებარე მიღება-ჩაბარების აქტი გაფორმებული ორი თანაბარი იურიდიული ძალის მქონე ეგზემპლარად  და გადაეცემა მხარეებს.
                  </Text>
                  <Text style={{marginTop:100}}></Text>
                  <Text style={styles.text}>
                    შპს „სერვისბოქსი“  წარმომადგენელი
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    აბონენტი
                  </Text>
                  <Text style={styles.text}>
                    /იაგო შიოლაშვილი/
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {this.props.match.params.firstname} {this.props.match.params.lastname}
                  </Text>
                  <Text style={styles.text}>
                    ______________________
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    _______________________
                  </Text>
                  
                </Page>
              </Document>
            </PDFViewer>
        )
    }
    
}

export default withRouter(RemoveContractDocument);
